<div class="rich-editor-dialog-container">
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title">
            {{title}}
        </div>
        <div class="nova__dialog__toolbar__controls">
            <button mat-icon-button class="nova__button--icon" [mat-dialog-close]="getResult(true)">
                <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
            </button>
        </div>
    </div>
    <div mat-dialog-content class="nova__dialog__content">
        <nova-rich-editor [(value)]="description" [maxlength]="maxLength" [useIframe]="false"
            (onValidityChange)="setDescriptionValidity($event)">
        </nova-rich-editor>

        <div class="text-info-container">
            @if (!isDescriptionValid) {
            <div class="error">Max limit {{ maxLength }} characters</div>
            }
        </div>

        <mat-dialog-actions class="nova__dialog__content__actions">
            <button mat-flat-button color="primary" [mat-dialog-close]="getResult()"
                [disabled]="isSaveDisabled()">save</button>
            <button mat-flat-button color="cancel" [mat-dialog-close]="getResult(true)">cancel</button>
        </mat-dialog-actions>
    </div>
</div>
